import {
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
} from '../constant';

export const getFailedCaseText = (tab) => {
  switch (tab) {
    case LIST_SP_TAB_SUMMARY:
      return "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.";
    case LIST_SP_TAB_HISTORY:
      return "The History tab didn't load properly due to a network issue. Please refresh or try again later.";
    case LIST_SP_TAB_PROGRESS:
      return "The Progress tab didn't load properly due to a network issue. Please refresh or try again later.";
    default:
      return '';
  }
};

export const decisionOrder = {
  'Manager Confirmed': 0,
  ManagerConfirmed: 0,
  'Manager Confirmed With End Date Changed': 1,
  ManagerConfirmedWithEndDateChanged: 1,
  'Not Confirmed By Manager': 2,
  Terminated: 3,
  Approved: 4,
  Rejected: 5,
  'End Date Changed': 6,
  EndDateChanged: 6,
  'Conditionally Certified': 7,
  ConditionallyCertified: 7,
  Reassigned: 8,
  'No Action Required': 9,
  NoActionRequired: 9,
};

export const customSortByDecision = (a, b) =>
  decisionOrder[a] - decisionOrder[b];

export default getFailedCaseText;
